export const ADMIN_GET_VENDOR = 'ADMIN_GET_VENDOR'
export const ADMIN_ADD_VENDOR = 'ADMIN_ADD_VENDOR'
export const ADMIN_UPDATE_VENDOR = 'ADMIN_UPDATE_VENDOR'
export const ADMIN_DELETE_VENDOR = 'ADMIN_DELETE_VENDOR'
